import React from 'react';
import { FormattedMessage } from 'react-intl';
import PhoneNumberField from './phoneNumberField';
import EmailField from './emailField';
import { useSelector } from 'react-redux';
import MarketingConsent from '../marketingConsent';

const PersonalDetails = () => {
  const { country_code } = useSelector((state: any) => state.company);

  return (
    <div className="personal-details">
      <p className="section-heading">
        <FormattedMessage
          id="my_account.personal_details"
          defaultMessage="Personal Details"
        />
      </p>
      <PhoneNumberField />
      <EmailField />
      {country_code === "SG" && <MarketingConsent />}
    </div>
  );
};

export default PersonalDetails;
